import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import parse from 'html-react-parser';
import axios from 'axios';
import callBanner from '../../../images/resource/call-bg.jpg'
import Header from '../../../components/User/Header/Header';
import Footer from '../../../components/User/Footer/Footer';

function BlogDetail() {
    const[blog,setBlog]=useState(null)
    const[latestBlogs,setLatestBlogs]=useState(null)
    const baseAPI = process.env.REACT_APP_API_URL;
    const {id}=useParams()
    const ImageAPI = process.env.REACT_APP_IMAGE_URL;
    useEffect(()=>{
if(id){
    console.log("id",id)
    getCurrentBlogDetail()
    getTopThreeBlogs()
}
    },[id])

    const getCurrentBlogDetail=()=>{
        axios
        .get(`${baseAPI}/CMB/GETBlogs?id=${id}`, {
          headers: {
          //   Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setBlog(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }

    const getTopThreeBlogs=()=>{
        axios
        .get(`${baseAPI}/Admin/GetTopThreeBlogs`, {
          headers: {
          //   Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          console.log(response.data.data)
          setLatestBlogs(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }

    console.log(latestBlogs)

    const getCurrentBlogImage = (image) => {
  return `${ImageAPI}Images/Blogs/${image}`;
    };

    const formatDate = (date) => {
      const dateString = new Date(date);
      return dateString.toLocaleDateString('en-US', { month: 'short', day: 'numeric',year:'numeric' });
    };

  return (
//     <section>
// <div class="page-wrapper">
//     {blog && blog.length>0?
//     blog.map((blog,idx)=>{
//         return <div>
//           <img/>
//           {parse(blog.Content)}
//           </div>

//     })
// :
//     null
//     }
// </div>

// <button class="scroll-top scroll-to-target" data-target="html">
//     <span class="fa fa-arrow-up"></span>
// </button>
//     </section>
<div class="page-wrapper">
  <Header/>
  <section>
  <section class="blog-details sp-nine">
{blog && blog.length>0?
<div class="container">
    <div class="row">
        <div class="col-xl-8 col-md-12 col-sm-12">
            <div class="blog-left-area">
                <div class="news-block-two">
                    <figure>
                        <img src={getCurrentBlogImage(blog[0].ImagePath)} alt={blog[0].ImagePath}/>
                    </figure>
                    <ul class="blog-info mt-2 mb-30">
                    <li><i class="fa fa-calendar"></i>{formatDate(blog[0].Created_On)}</li>
                    </ul>
                    <div className='blog-detail'>{parse(blog[0].Content)}</div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-md-12 col-sm-12">
            <div class="blog-right-area">
                <div class="category-list-area mb-30">
                    <div class="sec-title-two mb-35">
                        <h5>Category</h5>
                    </div>
                    <ul class="category-list">
                        <li><a href="#">Exercise Program (6)</a></li>
                        <li><a href="#">Balance Body Mind (9)</a></li>
                        <li><a href="#">Physical Activity (7)</a></li>
                        <li><a href="#">Improving Health (5)</a></li>
                        <li><a href="#">Personal Fitness (3)</a></li>
                    </ul>
                </div>
                <div class="blog-list-area mb-30">
                    <div class="sec-title-two mb-35">
                        <h5>Latest Articles</h5>
                    </div>
                    {latestBlogs && latestBlogs.length>0?
                    latestBlogs.map((blog,idx)=>{
                        return    <div class="blog-item-one">
                        <figure>
                            <img style={{paddingTop:'4px'}} src={getCurrentBlogImage(blog.ImagePath)} alt={blog.heading}/>
                        </figure>
                        <h6><a style={{padding:'0px'}} href={`/blog/${blog.URL}`}>{blog.heading}</a></h6>
                        <span>{formatDate(blog.Created_On)}</span>
                    </div>
                    })
                  
                    :
                    null}
                </div>
            </div>
        </div>
    </div>
</div>
:
null
}
</section>
  </section>
<Footer/>
</div>


  )
}

export default BlogDetail

    